import { getAuthToken } from '../utils/authUtils'; //

const API_BASE = process.env.REACT_APP_FIREBASE_BACKEND_API_BASE || 'https://quantumleap-emr-dev.web.app';
/**
 * Update user roles securely
 * @param {string} targetUserId - The user ID whose roles to update
 * @param {string[]} newRoles - Array of new roles to assign
 * @returns {Promise<Object>} Update result with before/after roles
 */
export const updateUserRoles = async (targetUserId, newRoles) => {
  try {
   
    const idToken = await getAuthToken();
    const response = await fetch(
      `${API_BASE}/admin/users/${targetUserId}/roles`,
      {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${idToken}`
        },
        body: JSON.stringify({ roles: newRoles })
      }
    );

    if (!response.ok) {
      throw new Error('Failed to update user roles');
    }

    const result = await response.json();
    return result;
  } catch (error) {
    console.error('Error updating user roles:', error);
    throw error;
  }
};

/**
 * Update user profile securely
 * @param {string} targetUserId - The user ID whose profile to update
 * @param {Object} profileData - Profile data to update
 * @returns {Promise<Object>} Update result with updated user data
 */
export const updateUserProfile = async (targetUserId, profileData) => {
  try {
    const idToken = await getAuthToken();
    const response = await fetch(
      `${API_BASE}/admin/users/${targetUserId}/profile`,
      {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${idToken}`
        },
        body: JSON.stringify(profileData)
      }
    );

    if (!response.ok) {
      throw new Error('Failed to update user profile');
    }

    const result = await response.json();
    return result;
  } catch (error) {
    console.error('Error updating user profile:', error);
    throw error;
  }
}; 

/**
 * Deactivate or activate a user
 * @param {string} targetUserId - The user ID whose status to change
 * @param {string} status - The new status ('active' or 'inactive')
 * @param {string} reason - Optional reason for deactivation
 * @returns {Promise<Object>} Update result with updated user data
 */
export const updateUserStatus = async (targetUserId, status, reason = null) => {
  try {
    const idToken = await getAuthToken();
    // Convert status string to active boolean for backend API
    const active = status === 'active';
    const response = await fetch(
      `${API_BASE}/admin/users/${targetUserId}/status`,
      {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${idToken}`
        },
        body: JSON.stringify({ active, reason })
      }
    );

    if (!response.ok) {
      throw new Error('Failed to update user status');
    }

    const result = await response.json();
    return result;
  } catch (error) {
    console.error('Error updating user status:', error);
    throw error;
  }
}; 